import generateToken from './generateToken'
import axios from 'axios'
import legolasApi from '../api/legolas'

const authProvider = {
  login: async (params) => {
    let finalResponse = null
    if (typeof params.username != 'undefined' && typeof params.password != 'undefined') {
        const data = params
        const signedToken = generateToken(data)
        const payload = { "action": "login" }

        await axios.post(`${legolasApi.url}/admin/auth/login`, payload, {
            headers: {
              'Authorization': `Bearer ${signedToken}`,
              'Content-Type': 'application/json'
            },
          }).then((res) => {
              finalResponse = res.data
              console.log('fin res: ', finalResponse)
              if(finalResponse.success){
                const userEmail = finalResponse.data.email
                const userObj = {
                  'id' : finalResponse.data.user_id ? finalResponse.data.user_id : undefined,
                  'firstname' : finalResponse.data.firstname ? finalResponse.data.firstname : undefined,
                  'lastname' : finalResponse.data.lastname ? finalResponse.data.lastname : undefined,
                  'email' : finalResponse.data.email ? finalResponse.data.email : undefined,
                  'admin_role_id' : finalResponse.data.admin_role_id,
              }
              localStorage.setItem('username', userEmail)
              localStorage.setItem('user', JSON.stringify(userObj))
            } 
            else {
              return Promise.reject("Invalid credentials");
          }
          })
          return finalResponse
    } else {
      console.log("eeeee");
        return Promise.reject()
        
    }
  },
  logout: () => {
      localStorage.removeItem('username');
      localStorage.removeItem('user');
      return Promise.resolve();
  },
  checkAuth: () => localStorage.getItem('username') ? Promise.resolve() : Promise.reject(),
  checkError:  (error) => {
      const status = error.status;
      if (status === 401 || status === 403) {
          localStorage.removeItem('username');
          localStorage.removeItem('user');
          return Promise.reject();
      }
      // other error code (404, 500, etc): no need to log out
      return Promise.resolve();
  },
  getIdentity: () => {
      const userDetails = JSON.parse(localStorage.getItem('user'))
      const firstname = userDetails.firstname
      const lastname = userDetails.lastname
      console.log(firstname, lastname)
      return Promise.resolve({
        id: 'user',
        fullName: `${firstname} ${lastname}`
    })
  },
  getPermissions: () => Promise.resolve(''),
};

export default authProvider
